import { Component, OnInit, Input } from "@angular/core";
import { HomeSlider } from "../../../shared/data/slider";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { CarouselModule } from "ngx-owl-carousel-o";

@Component({
  selector: "app-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, CarouselModule],
  schemas: [],
})
export class SliderComponent implements OnInit {
  public HomeSliderConfig: any = HomeSlider;

  @Input() sliders: any[];
  @Input() class: string;
  @Input() textClass: string;
  @Input() category: string;
  @Input() buttonText: string;
  @Input() buttonClass: string;

  constructor() {}

  ngOnInit(): void {}
}
